import type { Entity } from '@backstage/catalog-model';
import { useApi } from '@backstage/frontend-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useCallback, useEffect, useState } from 'react';

/**
 * The template entities behind `/create`.
 *
 * The stock page reaches for `EntityListProvider`, which drags in the whole
 * Material-UI catalog filter layout. The picker only needs the entities — its
 * filtering is local, over a handful of templates.
 */
export const useTemplates = () => {
  const catalogApi = useApi(catalogApiRef);
  const [templates, setTemplates] = useState<Entity[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | undefined>(undefined);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(undefined);

    catalogApi
      .getEntities({ filter: { kind: 'Template' } })
      .then(response => {
        if (active) setTemplates(response.items);
      })
      .catch(error_ => {
        if (active) setError(error_ as Error);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [catalogApi, attempt]);

  const reload = useCallback(() => setAttempt(current => current + 1), []);

  return { templates, loading, error, reload };
};
